import { useQuery } from "convex/react";
import { api } from "#convex/_generated/api.js";
import { Doc } from "#convex/_generated/dataModel.js";

export default function AgencyName({ region }: { region: Doc<"Region"> }) {
  const agency = useQuery(api.agencyAccount.getById, { id: region?.agencyAccount })
  return <>{agency?.name}</>
}